var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4875 12.275L2.375 26.375L0.625 24.625L14.725 10.5125L16.4875 12.275ZM22.0875 8.66249L22.825 7.92499L21.8375 6.93749L22.6375 6.13749L20.8625 4.36249L20.0625 5.16249L19.075 4.17499L18.3375 4.91249C16.1625 3.13749 13.7125 1.71249 11.0875 0.712494L10.05 2.94999C12.2375 4.09999 14.25 5.48749 16.125 7.12499L15.5 7.74999L19.25 11.5L19.875 10.875C21.5125 12.75 22.9 14.7625 24.05 16.95L26.2875 15.9125C25.2875 13.2875 23.8625 10.8375 22.0875 8.66249Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMine);
export default __webpack_public_path__ + "static/media/menu-mine.fcc3f371c99820dc1b2f84c52dc57d7d.svg";
export { ForwardRef as ReactComponent };